import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { IAPPlannedCourseDataSource } from '../../global/datasources/ap_planned_course_datasource';

angular
  .module('capability-ng-academic-planner')
  .service(
    'bulkLockUnLockCoursesCommand',
    function bulkLockUnLockCoursesCommand(
      defineCommandORM: IDefineCommand,
      ngAPPlannedCoursesDatasource: IAPPlannedCourseDataSource,
      $http: ng.IHttpService
    ) {
      return defineCommandORM(
        'bulkLockUnLockCoursesCommand',
        (deferred: any, courseIds: number[], isLocked: boolean = true) => {
          const data = _4.map(courseIds, (courseId: number) => ({
            id: courseId,
            is_locked: isLocked
          }));
          $http
            .put(`/academicplan/suggested_courses/`, data)
            .then(() => {
              _4.each(courseIds, (courseId) => {
                const plannedCourse = ngAPPlannedCoursesDatasource.get(courseId);
                if (plannedCourse) {
                  plannedCourse.is_locked = isLocked;
                  ngAPPlannedCoursesDatasource.put(plannedCourse);
                }
              });
              deferred.resolve();
            })
            .catch((e: any) => {
              deferred.reject(e);
            });
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/bulk_lock_unlock_courses_command.ts